import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';

var SvgMaf = function SvgMaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m2.903 3.774 10.43 13.56v14.58c-2.803-.16-5.398-.536-6.99-1.144C1.894 29.042.865 24.124.865 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .45-2.146 2.037-4.101Zm15.763 28.144V17.333L29.1 3.77c1.612 1.965 2.067 4.139 2.067 4.139.663 2.758.862 5.582.83 8.108.032 2.492-.2 5.316-.864 8.107 0 0-1.028 4.918-5.476 6.646-1.592.633-4.187.996-6.99 1.148Z",
    fill: "#227FBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.334 13.333h9.333l-4.667 6-4.666-6Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.666 12.667a3.333 3.333 0 1 1 6.667 0h-6.666Z",
    fill: "#F2C500"
  }));
};

export default SvgMaf;